import { columnWidthOptions } from './constants';

export function getTableColumnsSpec(headers) {
	const columnSpecs = headers
		.map((header) => {
			const headerWidth = header.width ?? 1;
			switch (headerWidth) {
				case columnWidthOptions.Half:
					return `minmax(0, 0.5fr)`;
				case columnWidthOptions.Double:
					return `minmax(0, 2fr)`;
				case columnWidthOptions.Triple:
					return `minmax(0, 3fr)`;
				case columnWidthOptions.Single:
				default:
					return `minmax(0, 1fr)`;
			}
		})
		.join(' ');
	return columnSpecs;
}
